import Vue from "vue";

import WebsiteTop from "@/components/normal/website-top";
Vue.component("website-top", WebsiteTop);

import WebsiteHead from "@/components/normal/website-head";
Vue.component("website-head", WebsiteHead);

import WebsiteSaasHead from "@/components/normal/website-saas-head";
Vue.component("website-saas-head", WebsiteSaasHead);

import WebsiteSlotHead from "@/components/normal/website-slot-head";
Vue.component("website-slot-head", WebsiteSlotHead);

import WebsiteFoot from "@/components/normal/website-foot";
Vue.component("website-foot", WebsiteFoot);

import NormalDialog from "@/components/normal/normal-dialog";
Vue.component("normal-dialog", NormalDialog);

import NormalDrawer from "@/components/normal/normal-drawer";
Vue.component("normal-drawer", NormalDrawer);

import NormalShare from "@/components/normal/normal-share";
Vue.component("normal-share", NormalShare);

import NormalPictureSelector from "@/components/normal/normal-picture-selector";
Vue.component("normal-picture-selector", NormalPictureSelector);

import NormalPreviewItem from "@/components/normal/normal-preview-item";
Vue.component("normal-preview-item", NormalPreviewItem);

import NormalPreviewMobiles from "@/components/normal/normal-preview-mobiles";
Vue.component("normal-preview-mobiles", NormalPreviewMobiles);

import AuthCheck from "@/components/work/auth-check";
Vue.component("auth-check", AuthCheck);

const component = {};
export default {
  component,
};
